
import React from 'react';
import {Link,useNavigate} from 'react-router-dom';
import { useState,useEffect } from "react";

function Home(navigation) {
  const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
  //alert(isLoggedIn);return false;
  const navigate = useNavigate();
  useEffect(()=>{
    if(isLoggedIn===true){
      navigate("/dashboard");
    }else{
      navigate("/login");
    }
  },[])

  return (
    <> 
      <h2>Home Page</h2>
    </>
  );
}

export default Home;
